import axios from "axios";

const consumptionBaseUrl = "/api/asset-consumption";
const schedulesBaseUrl = "/api/recurring-schedules";

const throwResponseData = (error) => {
  throw error.response?.data ?? error;
};

export const fetchAssetConsumption = async (companyKey, assetNodeId) => {
  try {
    const response = await axios.get(`${consumptionBaseUrl}/asset-node/${assetNodeId}`, {
      params: { companyKey },
    });
    return response.data;
  } catch (error) {
    throwResponseData(error);
  }
};

export const fetchSchedules = async (companyKey, assetNodeId) => {
  try {
    const response = await axios.get(schedulesBaseUrl, {
      params: { companyKey, assetNodeId, isActive: true },
    });
    return response.data;
  } catch (error) {
    throwResponseData(error);
  }
};

export const fetchScheduleConsumption = async (companyKey, scheduleId) => {
  try {
    const response = await axios.get(`${consumptionBaseUrl}/schedule/${scheduleId}`, {
      params: { companyKey },
    });
    return response.data;
  } catch (error) {
    throwResponseData(error);
  }
};